import { ReactElement, useEffect } from 'react'
import {
  fetchLinkedServices,
  selectLinkedServicesByIds,
  selectLinkedServicesStatus,
} from 'src/v3/manage/manage.slice'
import SelectLinkedService from 'src/v3/components/linked-service'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import useSession from 'src/authentication/hooks/use-session'
import { activeLinkedServiceChanged } from '../manage.slice'

interface Props {
  linkedServiceID: string
}

let LinkedService = ({ linkedServiceID }: Props): ReactElement => {
  let dispatch = useAppDispatch()
  let session = useSession()

  let linkedServicesStatus = useAppSelector(selectLinkedServicesStatus)
  let linkedServices = useAppSelector(
    selectLinkedServicesByIds(session?.linkedServices ?? []),
  )

  useEffect(() => {
    if (linkedServicesStatus === 'uninitialized') {
      dispatch(fetchLinkedServices())
    }
    if (linkedServicesStatus === 'fulfilled') {
      if (linkedServices.length === 1 && linkedServices[0].id) {
        dispatch(activeLinkedServiceChanged(linkedServices[0].id))
      }
    }
  }, [linkedServicesStatus])

  return (
    <div style={{ marginBottom: 14, marginTop: -6, textAlign: 'center' }}>
      <SelectLinkedService
        linkedServiceID={linkedServiceID}
        linkedServices={linkedServices}
        activeLinkedServiceChanged={activeLinkedServiceChanged}
      />
    </div>
  )
}

export default LinkedService
